// libraries
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
// commons
import CONSTANSTS from "common/constansts";
//component
import AppButton from "components/app-button";
// import AppInput from "components/app-input";
import pathnames from "routes/pathnames";
import AppCustomToast, { PageContext } from "components/app-custom-toast";
import { useEffect } from "react";

// api
// import api from "services/api";

const defaultPasswordState = {
  passwordMinEightChar: 0,
  passwordMinOneNumber: 0,
  passwordMinOneUppercase: 0,
  passwordMinOneSpecialChar: 0,
};


// const defaultPPreviousasswordState = {
//     passwordPreviousCantBeSame: 0
// }

const PageAddNewUser = () => {

  const options = {
    result:{
     Finance: "",
     "Processing Officer": "",
     "Credit Officer": ""
    }
   };
     //dynamically assigns select options data
     function Options({ options }) {
       return Object.keys(options).map((key,i) => (
         <option key={i} value={options[key]}>
           {key}
         </option>
       ));
     }
  
     const [optionsData, setOptionsData] = useState();
  useEffect(()=>{
    const fetchData = async () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
    fetch( process.env.REACT_APP_API_URL +CONSTANSTS.ENDPOINT_PATH.GET_ROLE_MAPPING,{
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => response.json())
    .then((response)=>{
      if(response.success){
        setOptionsData(response.result)
        }
        else{
          setOptionsData(options)
        }
  
    })
  } catch (error) {
    console.log(error);
  }
};
fetchData();
  },[])
    
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const history = useHistory();
  const [passwordRequirement, setPasswordRequirement] = useState(defaultPasswordState);
  // const [previousPasswordRequirement, setPreviousPasswordRequirement] = useState(defaultPPreviousasswordState);
  const { passwordMinEightChar, passwordMinOneUppercase, passwordMinOneNumber, passwordMinOneSpecialChar } = passwordRequirement;
  // const { passwordPreviousCantBeSame } = previousPasswordRequirement;

  const inputField = {
    staffID: {
      error: false,
      value: "",
      placeholder: "Staff ID",
      required: "",
      invalid: "",
    },
    staffName: {
      error: false,
      value: "",
      placeholder: "Enter Staff Name",
      required: "Cannot be empty",
      invalid: "",
    },
    emailAddress: {
      error: false,
      value: "",
      placeholder: "Enter Email Address",
      required: "Email required",
      invalid: "Invalid email",
    },
    role: {
      error: false,
      value: "",
      placeholder: "Select Role",
      required: "Role required",
      invalid: "Invalid Role",
    },
    password: {
      error: false,
      value: null,
      placeholder: "Enter Password",
      required: "Password required",
      invalid: "Invalid, please provide correct format",
    },
    reconfirmPassword: {
      error: false,
      value: "",
      placeholder: "Please enter reconfirm Password",
      required: "Reconfirm password required",
      invalid: "Invalid, please provide correct format",
    },
  };
  const [input, setInput] = useState(inputField);
  const [showPassword, setShowPassword] = useState(false);
  const [showReconfirmPassword, setShowReconfirmPassword] = useState(false);

  // const selectList = [
  //     { id: 1, value: "Admin", label: "A" },
  //     { id: 2, value: "Staff", label: "B" },
  // ];

  const back = async () => {
    history.push(pathnames.pageUserManagement);
  };

  // const fieldValidation = () => {
  //     setInput({
  //         ...input,
  //         staffName: {
  //             ...input.staffName,
  //             error: !input.staffName.value,
  //             placeholder: !input.staffName.value ? input.staffName.required : input.staffName.placeholder,
  //         },
  //         emailAddress: {
  //             ...input.emailAddress,
  //             error: !input.emailAddress.value,
  //             placeholder: !input.emailAddress.value ? input.emailAddress.required : input.staffName.placeholder,
  //         },
  //         password: {
  //             ...input.password,
  //             error: !input.password.value,
  //             placeholder: !input.password.value ? input.password.required : input.staffName.placeholder,
  //         },
  //         reconfirmPassword: {
  //             ...input.reconfirmPassword,
  //             error: !input.reconfirmPassword.value,
  //             placeholder: !input.reconfirmPassword.value ? input.reconfirmPassword.required : input.staffName.placeholder,
  //         },
  //     });
  //     setPasswordRequirement(defaultPasswordState);
  // };

  const newPasswordConfirmPasswordMatch = () => {
    const passwordMinEightChar = CONSTANSTS.REGEX.minEightChar.test(input.password.value);
    const passwordMinOneUppercase = CONSTANSTS.REGEX.atLeaseOneUppercase.test(input.password.value);
    const passwordMinOneNumber = CONSTANSTS.REGEX.atLeastOneNumber.test(input.password.value);
    const passwordMinOneSpecialChar = CONSTANSTS.REGEX.atLeaseOneSpecialChar.test(input.password.value);
    setPasswordRequirement({
      passwordMinEightChar: passwordMinEightChar ? -1 : 1,
      passwordMinOneNumber: passwordMinOneNumber ? -1 : 1,
      passwordMinOneUppercase: passwordMinOneUppercase ? -1 : 1,
      passwordMinOneSpecialChar: passwordMinOneSpecialChar ? -1 : 1,
    });
    if (!passwordMinEightChar || !passwordMinOneNumber || !passwordMinOneUppercase || !passwordMinOneSpecialChar) {
      setInput((prevState) => ({
        ...prevState,
        password: {
          ...prevState.password,
          error: true,
          placeholder: input.password.invalid,
          invalid: input.password.invalid,
        },
        reconfirmPassword: {
          ...prevState.reconfirmPassword,
          error: true,
          placeholder: input.reconfirmPassword.invalid,
          invalid: input.password.invalid,
        },
      }));
      return false;
    } else {
      return true;
    }
  };

  // const newPasswordCantBeSameAsPrevious = () => {
  //     if (sessionStorage.getItem("debugError") != undefined || sessionStorage.getItem("debugError") != null) {
  //         if (sessionStorage.getItem("debugError") == "New password cannot be same as previous password.") {
  //             setPreviousPasswordRequirement({
  //                 passwordPreviousCantBeSame: 1
  //             });
  //         } else {
  //             setPreviousPasswordRequirement({
  //                 passwordPreviousCantBeSame: -1
  //             });
  //         }
  //     }
  // }

  const newPasswordConfirmPasswordDoNotMatch = () => {
    if (input.password.value === input.reconfirmPassword.value) {
      return true;
    }
    setInput((prevState) => ({
      ...prevState,
      reconfirmPassword: {
        ...prevState.reconfirmPassword,
        error: true,
        value: "",
        invalid: "Passwords do not match",
      },
    }));
    setPasswordRequirement(defaultPasswordState);
    return false;
  };

  function validateEmail(email) {
    if (CONSTANSTS.REGEX.email.test(email)) {
      setInput((prevState) => ({
        ...prevState,
        emailAddress: {
          ...prevState.emailAddress,
          error: false,
          value: email,
          invalid: "",
        },
      }));
      return true;
    }
    setInput((prevState) => ({
      ...prevState,
      emailAddress: {
        ...prevState.emailAddress,
        error: true,
        value: email,
        invalid: CONSTANSTS.DISPLAY_TEXT.invalid_email,
      },
    }));
    return false;
  }

  function validateRoles(value) {
    if (value == "" || value == undefined) {
      setInput((prevState) => ({
        ...prevState,
        role: {
          ...prevState.role,
          error: true,
          invalid: CONSTANSTS.DISPLAY_TEXT.invalid_roles,
        },
      }));
      return false;
    }
    setInput((prevState) => ({
      ...prevState,
      role: {
        ...prevState.role,
        error: false,
        invalid: "",
      },
    }));
    return true;
  }

  
  const createNewUser = () => {
    // console.log("0", input);
    // if (!input.password.value || !input.reconfirmPassword.value || input.staffName.value || input.emailAddress.value) {
    //     fieldValidation();
    //     console.log("1");
    // } else {

    var checkPass = !newPasswordConfirmPasswordMatch();
    var checkEmail = !validateEmail(input.emailAddress.value);

    var checkRoles = !validateRoles(input.role.value);

    var samePass = !newPasswordConfirmPasswordDoNotMatch();
    if (checkEmail || checkPass || checkRoles || samePass) {
      return;
    }

    // console.log("2");

    // let userRequest = {
    //     email: input.emailAddress.value,
    //     name: input.staffName.value,
    //     password: input.reconfirmPassword.value,
    //     role: input.role.value,
    // }
    // fetch(api.post.createUser(userRequest));
    let token = null;
    token = localStorage.getItem("@storage_token");
    // fetch("http://49.0.203.50/ivc-app/bo/user/api/v1/create", {
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.CREATE_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        email: input.emailAddress.value,
        name: input.staffName.value,
        password: input.reconfirmPassword.value,
        role: input.role.value,
        hasAuthority: isApprove,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        console.log(items);
        if (items.responseCode === 200) {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: items.message });
          history.push(pathnames.pageUserManagement);
        } else {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: items.message, defaultOnClick: false });
        }
      });
    // console.log("userRequest", userRequest)

    // }
  };

  // const errorMessage = (name, value) => {
  //     if (!value) {
  //         return input[name].required;
  //     } else if (!input[name].regex.test(value)) {
  //         return input[name].invalid;
  //     } else {
  //         return "";
  //     }
  // };

  const onHandleOnChange = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    if (event.currentTarget.name == "emailAddress") {
      if (!validateEmail(event.currentTarget.value)) return;
    }
    setInput((prevState) => ({
      ...prevState,
      [name]: {
        ...input[name],
        error: "errorMessage(name, value)",
        value: value.replace(CONSTANSTS.REGEX.spaces, ""),
      },
    }));
  };

  const onHandle = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    setInput((prevState) => ({
      ...prevState,
      [name]: {
        ...input[name],
        value: value.replace(null, ""),
      },
    }));
  };

  const [isApprove, setIsApprove] = useState(false);
  const handleApprover = () => {
    setIsApprove(!isApprove);
  };

  return (
    <div className="page-user-management">
      <div className="top-context" style={{ padding: "0px 50px 30px 50px" }}>
        <div className="title">Add New User</div>
        <div style={{marginRight: "350px"}}>
          <div className="search-button">
            <AppButton colorType="orange" label="Cancel" onClick={back}></AppButton>
          </div>
          <div className="search-button">
            <AppButton colorType="orange" label="Add New User" onClick={createNewUser}></AppButton>
          </div>
        </div>
      </div>
      <div className="page-home-page">
        <div className="home-page">
          <div className="input-field">
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Staff ID</div>
              <div className="col-sm-9 col-md-9">
                <div className="app-input">
                  <input className="app-input-text" name="staffID" placeholder={input.staffID.placeholder} value={input.staffID.value} disabled />
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Staff Name</div>
              <div className="col-sm-9 col-md-9">
                <div className="app-input">
                  <input className="app-input-text" name="staffName" placeholder={input.staffName.placeholder} value={input.staffName.value} onChange={onHandle} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field"></div>
              <div className="col-sm-9 col-md-9">{input.staffName.error == true ? <div className="error">{"● " + input.staffName.invalid}</div> : null}</div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field update-page">Email Address</div>
              <div className="col-sm-9 col-md-9">
                <div className="app-input">
                  <input id="emailAddress" className="app-input-text" name="emailAddress" placeholder={input.emailAddress.placeholder} value={input.emailAddress.value} onChange={onHandleOnChange} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field"></div>
              <div className="col-sm-9 col-md-9"> {input.emailAddress.error == true ? <div className="error">{"● " + input.emailAddress.invalid}</div> : null}</div>
            </div>

            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Role</div>
              <div className="col-sm-9 col-md-9">
                {/* <AppInput type="select" selectList={selectList} name="role" placeholder={inputField.role.placeholder} value={input.role.value} onChange={onHandleOnChange} /> */}
                <div className="app-input">
                  <select className="app-input-select app-input-select__input" name="role" onChange={onHandleOnChange} value={input.role.value}>
                    {/* <option value="">- Select Role -</option>
                    <option value="ADMIN">Admin</option>
                    <option value="STAFF">Staff</option> */}
                    <option value="">- Select Role -</option>
                     <Options options={optionsData || options} /> 
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field"></div>
              <div className="col-sm-9 col-md-9"> {input.role.error == true ? <div className="error">{"● " + input.role.invalid}</div> : null}</div>
            </div>

            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Password</div>
              <div className="col-sm-9 col-md-9">
                <div className="app-input">
                  <input
                    className="app-input-text"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder={input.password.placeholder}
                    value={input.password.value}
                    onChange={onHandleOnChange}
                  />
                  <div className="app-input-password" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <IoEyeOffOutline size={24} /> : <IoEyeOutline size={24} />}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field"></div>
              <div className="col-sm-9 col-md-9"> {input.password.error == true ? <div className="error">{"● " + input.password.invalid}</div> : null}</div>
            </div>

            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Reconfirm Password</div>
              <div className="col-sm-9 col-md-9">
                <div className="app-input">
                  <input
                    className="app-input-text"
                    name="reconfirmPassword"
                    type={showReconfirmPassword ? "text" : "password"}
                    placeholder={input.reconfirmPassword.placeholder}
                    value={input.reconfirmPassword.value}
                    onChange={onHandleOnChange}
                  />
                  <div className="app-input-password" onClick={() => setShowReconfirmPassword(!showReconfirmPassword)}>
                    {showReconfirmPassword ? <IoEyeOffOutline size={24} /> : <IoEyeOutline size={24} />}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-md-3 text-field"></div>
              <div className="col-sm-9 col-md-9">
                {input.reconfirmPassword.error == true ? (
                  <div className="error">
                    {"● " + input.reconfirmPassword.invalid}
                    {passwordMinEightChar === 1 ? "\n● Use at least 8 characters" : null}
                    {passwordMinOneSpecialChar === 1 ? "\n● Should contain at least 1 special character" : null}
                    {passwordMinOneUppercase === 1 ? "\n● Should contain at least 1 uppercase" : null}
                    {/* {passwordPreviousCantBeSame === 1 ? <p>Cannot be same as previous password</p> : null} */}
                    {passwordMinOneNumber === 1 ? "\n● Should contain at least 1 numeric" : null}
                  </div>
                ) : null}
              </div>
            </div>
            <br />

            <div className="row">
              <div className="col-sm-3 col-md-3 text-field">Approver</div>
              <div className="col-sm-9 col-md-9">
                <div style={{ float: "left", margin: "5px 0px 0px 0px" }}>
                  <input type="checkBox" id="approver-button" className="check-box" onChange={handleApprover} checked={isApprove} />
                  <label htmlFor="approver-button" style={{ marginLeft: "20px", fontSize: "18px" }}>
                    Approver
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAddNewUser;
